// extracted by mini-css-extract-plugin
module.exports = {"CreditSlider":"style_CreditSlider__0Shaq","currencySelector":"style_currencySelector__nzaNT","currencySelector-popup":"style_currencySelector-popup__YE9KQ"};